import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './AchievementToasts.css';

const AUTO_DISMISS_MS = 40_000;

const AchievementToast = ({ achievement, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => onClose(achievement.id), AUTO_DISMISS_MS);
        return () => clearTimeout(timer);
    }, [achievement.id, onClose]);

    return (
        <div className="achievement-toast">
            <button
                className="achievement-toast__close"
                onClick={() => onClose(achievement.id)}
                aria-label="Close achievement"
            >
                ×
            </button>
            <span className="toast-label">Achievement Unlocked 🎖️</span>
            <span className="toast-title">{achievement.title}</span>
            <span className="toast-message">{achievement.description}</span>
            <div className="achievement-toast__timer" />
        </div>
    );
};

const AchievementToasts = ({ achievements, onClose }) => {
    if (!achievements.length) return null;

    return ReactDOM.createPortal(
        <div className="achievement-toasts-container">
            {achievements.map((a) => (
                <AchievementToast key={a.id} achievement={a} onClose={onClose} />
            ))}
        </div>,
        document.body
    );
};

export default AchievementToasts;
